export const userName = ({
    firstName,
    lastName,
    middleName,
}: {
    firstName?: string | null;
    lastName?: string | null;
    middleName?: string | null;
}) => ({
    short: [
        lastName || '',
        firstName ? ` ${firstName?.slice(0, 1)}.` : '',
        middleName ? ` ${middleName?.slice(0, 1)}.` : '',
    ]
        .filter(Boolean)
        .join(' '),
    full: [lastName, firstName, middleName].filter(Boolean).join(' '),
});
